// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141847/js/" + chunkId + "." + {"44":"1e5905ec","225":"f97f9564","481":"8cb77766","486":"3d20c488","770":"923719d2"}[chunkId] + ".0.30654109704003274.chunk.js";
};